import React, { useEffect } from "react";
import { FormGroup, Input, FormFeedback, Label } from "reactstrap";
import PopoverItem from "../common/PRpopover";

const PRInput = (props) => {
    const [charCount, setCharCount] = React.useState(0);

    useEffect(() => {
        if (props.elem.name && (props.elem.name === "additionalDetail" || props.elem.name === "problemLocation" || props.elem.name === "locationDetails")) {
            // console.log("props.elem.name");
            try {
                let el = document.getElementById(props.elem.name);

                if (el) {
                    //el.textContent = props.elem.value;

                    el.classList.remove("is-valid");
                    el.classList.remove("is-invalid");

                    if (props.elem.value && props.elem.value.length > 0) {
                        el.classList.add("is-valid");
                        setCharCount(props.elem.value.length); // Set initial count
                    } else {
                        if (props.elem.required) el.classList.add("is-invalid");
                        setCharCount(0);
                    }
                }
            } catch (ex) { console.log(ex); }
        }
    }, [props.elem.required, props.elem.value]);
    return (
        <>
            {props.elem.disable ? (
                ""
            ) : (
                <FormGroup>
                    <Label className={props.elem.fontWeight ? "label-font" : ""}>
                        {props.translate(props.lang, props.elem.label)}{" "}

                        {props.elem.required ? " " :
                            (props.elem.name != "SRnumber" && props.elem.name != "SRRstatus" && props.elem.name != "DateInvtDone") ?
                                <span className="colorred">{props.translate(
                                    props.lang, "optionalSign")}</span> : ""}
                    </Label>
                    <PopoverItem elem={props.elem} translate={props.translate} lang={props.lang} />


              {(props.elem.name !== "additionalDetail" && props.elem.name !== "problemLocation" && props.elem.name !== "locationDetails") ?
    <>
        <div style={{ position: 'relative' }}>
            <Input
                key={props.elem.name}
                type={(props.elem.name === "email") ? "email" : ((props.elem.name !== "additionalDetail" && props.elem.name !== "problemLocation" && props.elem.name !== "locationDetails") ? "text" : "textarea")}
                disabled={props.disabled ? "disabled" : ""}
                name={props.elem.name}
                id={props.elem.name}
                placeholder={props.placeholder ? ((props.translate(props.lang, props.placeholder) !== props.elem.name + "Placeholder") ? props.translate(props.lang, props.placeholder) : "") : ""}
                value={(props.elem.value) ? props.elem.value : ""}
                maxLength={props.elem.maxLength}
                style={!props.elem.disable && props.elem.name != "SRnumber" && props.elem.name !== "SRlastName" ? { paddingRight: '80px' } : {}}
                valid={((props.elem.name != "SRnumber" && props.elem.name != "SRRstatus" && props.elem.name != "DateInvtDone" && props.elem.name !== "SRlastName") && (
                    (props.elem.required && props.elem.value && props.elem.value.length > 0 && props.elem.status == 0) ||
                    (!props.elem.required && ((props.elem.status == 0) || (!props.elem.value)))))}
                invalid={
                    (props.elem.name != "SRnumber" && props.elem.name != "SRRstatus" && props.elem.name != "DateInvtDone" && props.elem.name !== "SRlastName") &&
                    !((props.elem.name != "SRnumber" && props.elem.name != "SRRstatus" && props.elem.name != "DateInvtDone" && props.elem.name !== "SRlastName") && (
                        (props.elem.required && props.elem.value && props.elem.value.length > 0 && props.elem.status == 0) ||
                        (!props.elem.required && ((props.elem.status == 0) || (!props.elem.value)))))}
                onClick={(e) => {
                    props.validate(e);
                }}
                onKeyUp={(e) => {
                    props.validate(e, props.elem.maxLength);
                    setCharCount(e.target.value.length);
                }}
                onChange={(e) => {
                    props.validate(e, props.elem.maxLength);
                    setCharCount(e.target.value.length);
                }}
            />
            {!props.elem.disable && props.elem.name != "SRnumber" && props.elem.name !== "SRlastName" ? (
                <div style={{ 
                    position: 'absolute', 
                    right: '30px', 
                    top: '50%', 
                    transform: 'translateY(-50%)', 
                    fontSize: '0.875rem', 
                    color: '#6c757d',
                    pointerEvents: 'none'
                }}>
                    {charCount} / {props.elem.maxLength}
                </div>) : ""}
        </div>
    </>
        :
    <>
        <div style={{ position: 'relative' }}>
            <span className="form-control textareaEdit" role="textbox" contentEditable
                key={props.elem.name}
                name={props.elem.name}
                id={props.elem.name}
                data-placeholder={props.placeholder ? ((props.translate(props.lang, props.placeholder) !== props.elem.name + "Placeholder") ? props.translate(props.lang, props.placeholder) : "") : ""}
                style={{ paddingRight: '80px', minHeight: '38px' }}
                onKeyDown={(e) => {
                    if (e.key.length === 1 && !e.ctrlKey && !e.metaKey &&
                        e.currentTarget.textContent.length >= props.elem.maxLength) {
                        e.preventDefault();
                    }
                }}
                onPaste={(e) => {
                    e.preventDefault();
                    const remaining = props.elem.maxLength - e.currentTarget.textContent.length;
                    if (remaining <= 0) return;
                    const text = (e.clipboardData || window.clipboardData).getData('text/plain');
                    document.execCommand('insertText', false, text.substring(0, remaining));
                }}
                onInput={(e) => {
                    const text = e.currentTarget.textContent;
                    setCharCount(Math.min(text.length, props.elem.maxLength));
                    try { e.currentTarget.classList.remove("is-valid"); } catch { }
                    try { e.currentTarget.classList.remove("is-invalid"); } catch { }
                    try {
                        if (e.currentTarget.textContent && e.currentTarget.textContent.length > 0) {
                            e.currentTarget.classList.add("is-valid");
                        } else {
                            if (props.elem.required) e.currentTarget.classList.add("is-invalid");
                        }
                        if (e && e.currentTarget && typeof e.currentTarget.textContent === "string") {
                            props.elem.value = e.currentTarget.textContent;
                        }
                        props.validateSpan(e, props.elem.name);
                    } catch { }
                }}
            ></span>
            {!props.elem.disable ? (
                <div style={{ 
                    position: 'absolute', 
                    right: '30px', 
                    bottom: '10px',
                    fontSize: '0.875rem', 
                    color: '#6c757d',
                    pointerEvents: 'none'
                }}>
                    {charCount} / {props.elem.maxLength}
                </div>) : ""}
        </div>
    </>
                    }
                    <FormFeedback>
                        {props.elem.required && (!props.elem.value || props.elem.value === "")
                            ?

                            (props.elem.errorlabel && props.elem.errorlabel.length > 0 ? props.translate(props.lang, props.elem.errorlabel)
                                : props.translate(props.lang, props.elem.label).replace(':', '') + " " + props.translate(props.lang, "isRequired") + '. ')
                            : ""}
                    </FormFeedback>
                </FormGroup>
            )}
        </>
    );
};

export default PRInput;

// PRInput.propTypes = {
//   onChange: PropTypes.func.isRequired,
// };
